export const LOCAL_WORKSPACE_LOCAL_STORAGE_KEY = 'affine-local-workspace';
export const LOCAL_WORKSPACE_CREATED_BROADCAST_CHANNEL_KEY =
  'affine-local-workspace-created';
